import { GET_ARTICLES_LIST, GET_ARTICLE, CLEAN_ARTICLE } from '../actions/types';

const initialState = {
	articles_list: [],
	article: [],
};

export default function (state = initialState, action) {
	switch (action.type) {
		case GET_ARTICLES_LIST:
			const append = action.meta?.append;
			return {
				...state,
				articles_list: append
					? {
							...action.payload,
							items: [...state.articles_list.items, ...action.payload.items],
					  }
					: action.payload,
			};
		case GET_ARTICLE:
			return {
				...state,
				article: action.payload,
			};
		case CLEAN_ARTICLE:
			return initialState;
		default:
			return state;
	}
}
